export function NotificationIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Notifications"
      role="img"
    >
      <path
        d="M10.02 2.42C7.26 2.42 5.02 4.67 5.02 7.42V9.83C5.02 10.34 4.8 11.12 4.54 11.55L3.58 13.14C2.99 14.12 3.4 15.22 4.48 15.58C8.08 16.78 11.95 16.78 15.54 15.58C16.55 15.25 16.99 14.06 16.44 13.14L15.48 11.55C15.23 11.12 15.02 10.34 15.02 9.83V7.42C15.02 4.67 12.77 2.42 10.02 2.42Z"
        stroke="#5C616C"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M11.56 2.67C11.3 2.59 11.03 2.53 10.76 2.5C9.96 2.4 9.19 2.46 8.47 2.67C8.72 2.05 9.32 1.62 10.02 1.62C10.72 1.62 11.32 2.05 11.56 2.67Z"
        stroke="#5C616C"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.52 15.88C12.52 17.26 11.39 18.38 10.02 18.38C9.33 18.38 8.7 18.1 8.25 17.65C7.8 17.2 7.52 16.57 7.52 15.88"
        stroke="#5C616C"
        strokeWidth="1.25"
        strokeMiterlimit="10"
      />
    </svg>
  );
}
